import { BASE_URL } from "../config/api";

export const createPopup = async (formData) => {
  const token = localStorage.getItem("token");

  const response = await fetch(`${BASE_URL}/popup/createPopup`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });

  const result = await response.json();

  if (!response.ok) {
    throw new Error(result.message || "Failed to create popup.");
  }

  return result;
};

export const updatePopup = async (id, formData) => {
  const token = localStorage.getItem("token");

  const response = await fetch(`${BASE_URL}/popup/updatePopup/${id}`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });

  const result = await response.json();

  if (!response.ok) {
    throw new Error(result.message || "Failed to update popup.");
  }

  return result;
};

export const fetchAllPopup = async () => {
  const response = await fetch(`${BASE_URL}/popup/fetchAllPopup`);

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || "Failed to fetch popups");
  }

  const data = await response.json();
  return data.popups;
};

export const fetchPopupById = async (id) => {
  const response = await fetch(`${BASE_URL}/popup/fetchPopupById/${id}`);

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || "Failed to fetch popup");
  }

  const data = await response.json();
  return data.popup;
};

export const deletePopup = async (id) => {
  const token = localStorage.getItem("token");

  const response = await fetch(`${BASE_URL}/popup/deletePopup/${id}`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const result = await response.json();

  if (!response.ok) {
    throw new Error(result.message || "Failed to delete popup.");
  }

  return result;
};